// src/components/home/HomePricingSection.js
import React from 'react';
import PricingPlanCard from '../tarifs/PricingPlanCard'; // Ajustez le chemin si nécessaire
import './HomePricingSection.css'; // Styles spécifiques pour cette section sur la page d'accueil

// Données des 3 offres de base, inspirées de votre TarifsPage.js
const homePricingPlansData = [
  { 
    id: "home-essential", 
    title: "Plan Essentiel", 
    price: "1 490€", 
    term: "projet unique", 
    features: [
      "Site vitrine (one page)", 
      "Design responsive", 
      "Formulaire de contact", 
      "Optimisation SEO de base",
      "Hébergement inclus"
    ], 
    ctaText: "Choisir Essentiel", 
    ctaLink: "/contact?service=Plan Essentiel", 
    isFeatured: false 
    // featureDetails n'est pas affiché par PricingPlanCard directement,
    // mais on pourrait le garder si on prévoit une modale "détails" plus tard.
    // Pour l'instant, on se concentre sur ce que PricingPlanCard affiche.
  },
  { 
    id: "home-pro", 
    title: "Plan Pro", 
    price: "2 890€", 
    term: "projet unique", 
    features: [ 
      "Site vitrine avancé (jusqu'à 15 pages)", 
      "Design personnalisé", 
      "Blog intégré", 
      "Optimisation SEO avancée", 
      "Support prioritaire (3 mois)",
      "Hébergement inclus" 
    ], 
    ctaText: "Opter pour Pro", 
    ctaLink: "/contact?service=Plan Pro", 
    isFeatured: true // Le Plan Pro est souvent mis en avant
  },
  { 
    id: "home-custom", 
    title: "Plan Sur Mesure", 
    price: "Devis", 
    term: "selon besoins", 
    features: [ 
      "Site vitrine avancé ou E-commerce",
      "Fonctionnalités complexes",
      "Applications web et mobile",
      "Intégrations API tierces",
      "Gestion base de données",
      "Accompagnement et maintenance",
      "...",
    ], 
    ctaText: "Demander un devis", 
    ctaLink: "/contact?service=Plan Sur Mesure", 
    isFeatured: false 
  }
];

function HomePricingSection() {
  return (
    <section className="home-pricing-section full-width-row"> {/* full-width-row pour un fond potentiel */}
      <div className="container"> {/* container pour centrer le contenu */}
        <h2 className="section-title">Nos Solutions Adaptées à Vos Projets</h2>
        <p className="section-intro">
          Que vous soyez une startup, une PME ou un grand compte, nous avons l'offre qu'il vous faut.
        </p>
        <div className="home-pricing-grid">
          {homePricingPlansData.map(plan => (
            <PricingPlanCard key={plan.id} plan={plan} />
          ))}
        </div>
        <div className="text-center more-pricing-link">
            <a href="/tarifs" className="cta-button-outline">Voir tous nos tarifs et options</a>
        </div>
      </div>
    </section>
  );
}

export default HomePricingSection;